import api from './utilBackoffice';

const controller = 'GrupoRedeLoja';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  Create: dto => api.Axios.Post(url, dto),
  Delete: id => api.Axios.Delete(url, id),
  GetGrupoRedeLoja: dto =>
    api.Axios.GetParams(url + '/GetByCodigoRedeLoja', dto),
  GetNomesByCodigoGrupo: dto =>
    api.Axios.GetParams(url + '/GetNomesByCodigoGrupo', dto),
  DeleteByCodigoComissionamento: dto =>
    api.Axios.Post(url + '/DeleteByCodigoComissionamento', dto)
});
